import type { FormChatState } from "../repositories/formChat.repository";

const ensureHms = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed) return trimmed;
  const parts = trimmed.split(":");
  if (parts.length === 2) {
    return `${parts[0].padStart(2, "0")}:${parts[1].padStart(2, "0")}:00`;
  }
  return trimmed;
};

export const buildDefaultMinConfirmedMembers = (memberCount: number): number =>
  Math.max(1, Math.floor(Math.max(0, memberCount) / 2) + 1);

export const normalizeActivityFormChatState = (
  data: FormChatState,
  ownerMediumId?: string,
): FormChatState => {
  const next: FormChatState = { ...data };
  const memberIds = [...(next.memberIds ?? [])];

  if (memberIds.length === 0 && ownerMediumId) {
    memberIds.push(ownerMediumId);
    next.memberIds = memberIds;
  }

  if (next.minConfirmedMembers === undefined && memberIds.length > 0) {
    next.minConfirmedMembers = buildDefaultMinConfirmedMembers(memberIds.length);
  }

  if (next.isAllDay === true) {
    next.startTime = "00:00:00";
    next.endTime = "23:59:59";
  } else {
    if (typeof next.startTime === "string" && next.startTime.trim()) {
      next.startTime = ensureHms(next.startTime);
    }
    if (typeof next.endTime === "string" && next.endTime.trim()) {
      next.endTime = ensureHms(next.endTime);
    }
  }

  if (next.checkinStartWindowMinutes === undefined) {
    next.checkinStartWindowMinutes = 10;
  }
  if (next.checkinEndWindowMinutes === undefined) {
    next.checkinEndWindowMinutes = 15;
  }

  return next;
};
